import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { ButtonComponent } from '@cue/ui';
import { cueClose, IconComponent } from '@cue/ui/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { translation } from '@cue/translations';
import { CdkConnectedOverlay, Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'cue-inactivity-warning',
  templateUrl: './inactivity-warning.component.html',
  styleUrl: './inactivity-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent, TranslocoPipe, CdkConnectedOverlay],
})
export class InactivityWarningComponent {
  overlay = inject(Overlay);
  globalOverlay = this.overlay.position().global().centerHorizontally().centerVertically() as any;

  digitalSignageOn = input<boolean>(false);
  countdown = input<number>(0);
  protected readonly translation = translation;

  ICONS = {
    cueClose,
  };
}
